import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppSettingsService } from '../../appsettings/appsettings.service';
 
@Injectable()
export class ProfileService 
{
	readonly rootUrl = environment.ProNetApiRootUrl; // 'http://localhost:3001';

	constructor(private httpClient: HttpClient, env: AppSettingsService) { 
		this.rootUrl = env.config.ProNetApiRootUrl; }
	
	get userProfile(){		
		if (sessionStorage.getItem('userProfile') != null)
			return JSON.parse(sessionStorage.getItem('userProfile'));
		else
			return this.getProfile();
	}
	
	getProfile() : Observable<any>
	{
		const headers = new HttpHeaders(
		{
			'No-Auth':'False',
			'Content-Type': 'application/json'
		});

		return this.httpClient.get(`${this.rootUrl}/api/profile`, {headers:headers, withCredentials:true});
	}

	updateProfile(profile) : Observable<any>
	{
		console.log("posting", profile);
		
		const headers = new HttpHeaders(
		{
			'No-Auth':'False',
			'Content-Type': 'application/json'
		});

		return this.httpClient.post(`${this.rootUrl}/api/profile/update`, profile, {headers:headers, withCredentials:true});
	}
}